import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const MaskLines = ({ lines, className = "", delay = 0, lineClass = "" }) => (
  <span className={className}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${typeof l === "object" && l.className ? l.className : lineClass}`}
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, ease, delay: delay + i * 0.12 }}
        >
          {typeof l === "object" ? l.text : l}
        </motion.span>
      </span>
    ))}
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0.001, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, ease, delay }}
    >
      {children}
    </M>
  );
};

export const Eyebrow = ({ children, dark = false }) => (
  <p className={`font-mono-x text-xs uppercase tracking-[0.22em] font-semibold flex items-center gap-3 ${dark ? "text-[#ff8fbf]" : "text-[#c8106a]"}`}>
    <span className="h-px w-8 bg-brand-gradient inline-block" />
    {children}
  </p>
);
